import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import UsernameModal from "../../modal/UsernameModal";
import { splitName } from "../../utils";
import { updateTicketNamesApi } from "../../services/nameUpdateServices";
import Loader from "../../compoment/ui/Loader";
import { toast } from "react-toastify";

const MainScreen = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState("");
    const [nameModal, setNameModal] = useState(true); // Start with modal hidden
    const [name, setName] = useState("");
    const [nameErr, setNameErr] = useState("");
    const [loading, setLoading] = useState(false)

    const [ticketData, setTicketData] = useState<any>({});

    // get ticket detail
    useEffect(() => {
        const storedData = localStorage.getItem("ticket_detail");
        if (storedData) {
            try {
                const parsedData = JSON.parse(storedData);
                setTicketData(parsedData);
            } catch (error) {
                console.error("Error parsing ticket_detail from localStorage:", error);
            }
        }
    }, []);

    // Check if name was passed through navigation state or exists in Redux
    useEffect(() => {
        const navigationState = window.history.state;
        if (ticketData && ticketData?.first_name && ticketData?.last_name) {
            const fullName = `${ticketData?.first_name} ${ticketData?.last_name}`;
            setName(fullName);
            setNameModal(false);
        } else if (navigationState?.userName) {
            setName(navigationState.userName);
            setNameModal(false);
        } else {
            setNameModal(true);
        }
    }, [ticketData, ticketData?.first_name, ticketData?.last_name]);

    // handle name submit
    const handleSubmit = async () => {
        if (!name.trim()) {
            setNameErr("Name field is required.");
            return;
        }
        setNameErr("");
        const { firstName, lastName } = splitName(name);

        if (!ticketData?.id) {
            toast.error("Invalid ticket data.");
            return;
        }

        try {
            setLoading(true);
            const response = await updateTicketNamesApi(ticketData.id, {
                first_name: firstName,
                last_name: lastName || " ",
            });

            if (response?.success) {
                const updatedTicket = {
                    ...ticketData,
                    first_name: firstName,
                    last_name: lastName || " ",
                };
                localStorage.setItem("ticket_detail", JSON.stringify(updatedTicket))
                toast.success("Ticket name updated successfully.");
            } else {
                console.error("Failed to update ticket names:", response?.error);
                toast.error(response?.message || "Error updating ticket names.");
            }
        } catch (error) {
            console.error("Error updating ticket names:", error);
            toast.error("Something went wrong while updating the ticket name.");
        } finally {
            setLoading(false);
            setNameModal(false);
        }
    };


    return (
        <>
            {loading && <Loader />}
            <section className="mainSection">
                <div className="d-flex justify-content-center h-100 flex-column">
                    <div className="scanCard mx-auto">
                        <div className="heading">Type the negative thought that bothers you the most</div>
                        <textarea
                            name="negativeThought"
                            id="negativeThought"
                            placeholder="Type here"
                            maxLength={80}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        ></textarea>
                        <div className="text-muted d-flex justify-content-between">
                            <small className="text-muted">Maximum of 80 characters only. </small>
                            <small className="text-muted">{message?.length}/80</small>
                        </div>
                        <div className="my-3">
                            <button
                                className="btnScanNow mb-0"
                                onClick={() => navigate("/release", { state: { message } })}
                                disabled={!message.trim()}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {nameModal && (
                <UsernameModal
                    show={nameModal}
                    onHide={() => setNameModal(false)}
                    name={name}
                    setName={setName}
                    nameErr={nameErr}
                    handleSubmit={handleSubmit}
                    setNameErr={setNameErr}
                />
            )}
        </>
    );
};

export default MainScreen;
